import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { StageLegacy } from "@silvertours/front-features";
import { Runtime } from "@silvertours/front-entities";
var WidgetPage = function() {
    var baseImageUrl = Runtime.useHost().baseImageUrl;
    return /*#__PURE__*/ _jsx(StageLegacy.WidgetStage, {
        baseImageUrl: baseImageUrl
    });
};
export { WidgetPage };
